import { Formik, FormikHelpers } from 'formik';
import { SelectItem } from '../../../../common/ui-components/multi-select/multi-select.component';
import { UserModel } from '../../../users/models/user-model';
import { createAccount } from '../../account-service';
import EditAccount, {
    EditAccountFormValue,
    EditAccountProps,
    formSchema
} from '../../components/edit-account.component';
import { AssignedUser } from '../../models/account-create-model';
import { useNavigate } from 'react-router';

const mapSelectItemsToUsers = (
    items: SelectItem<UserModel>[],
    isAccountManager: boolean
): AssignedUser[] => items.map(u => u.value).map(u => ({ ...u, isAccountManager }));

const CreateAccount = (props: EditAccountProps) => {
    const navigate = useNavigate();

    const onCreate = (
        formValue: EditAccountFormValue,
        actions: FormikHelpers<EditAccountFormValue>
    ) => {
        const { teams, users, accountManagers, ...fields } = formValue;
        createAccount({
            teams: teams.map(t => t.value),
            users: [
                ...mapSelectItemsToUsers(accountManagers, true),
                ...mapSelectItemsToUsers(users, false)
            ],
            ...fields
        })
            .then(() => navigate(-1))
            .finally(() => actions.setSubmitting(false));
    };

    return (
        <Formik
            initialValues={{
                name: '',
                users: [],
                accountManagers: [],
                teams: [],
                surveyQuota: '' as any,
                teamQuota: '' as any,
                validFrom: '' as any,
                validUntil: '' as any
            }}
            validationSchema={formSchema}
            onSubmit={onCreate}
        >
            {formikProps => <EditAccount {...props} {...formikProps} />}
        </Formik>
    );
};

export default CreateAccount;
